/*
 * File: /src/router/routes/cartAbandons.js
 * Created Date: Friday September 26th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 27th September 2025 11:08:25 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */

const CartAbandonList = () =>
  import(
    /* webpackChunkName: "CartAbandon" */ 'src/components/Dashboard/Views/CartAbandons/CartAbandonList.vue'
  );

export const cartAbandonRoutes = [
  {
    path: 'cart-abandons',
    name: 'Cart Abandons',
    component: CartAbandonList,
  },
];